<template>
  <step-display background-image="Reem/successBG.svg" mobile-background-image="Reem/mobileSuccessBG.png" :current-step="NaN">
    <success />
  </step-display>
</template>

<script>
import StepDisplay from "@/components/global/StepDisplay";
import Success from "@/components/steps/SuccessMsg";

export default {
  name: "SuccessMsg",
  components: {
    StepDisplay,
    Success
  },
  mounted() {
    setTimeout(() => {
      this.$router.push({ name: 'Choose Adwords Account' });
    }, 2000);
  },
}
</script>

<style scoped>

</style>